import Reorder from '@mui/icons-material/Reorder';

const BarcodeIcon = () => {
    return (
        <Reorder  sx={{transform:'rotate(90deg)'}}/>
    )
}

export default BarcodeIcon;